import clsx from "clsx";
import { type PropsWithChildren } from "react";

import { useMainScroll } from "@/hooks/useMainScroll";

export function StickyHeader({ children }: PropsWithChildren) {
  const { y: scrollY } = useMainScroll();

  return (
    <div
      ref={setupStickyHeaderHeightVariable}
      className={clsx(
        "sticky top-0 z-50 shrink-0 bg-surface-background transition-shadow duration-300 ease-out",
        scrollY > 0 ? "shadow-2xs" : "shadow-none",
      )}
    >
      {children}
    </div>
  );
}

function setupStickyHeaderHeightVariable(el: HTMLElement | null) {
  if (!el) return;

  const propName = "--sticky-header-height";

  const observer = new ResizeObserver(() => {
    document.documentElement.style.setProperty(
      propName,
      `${el.offsetHeight}px`,
    );
  });

  observer.observe(el);

  return () => {
    document.documentElement.style.removeProperty(propName);
    observer.disconnect();
  };
}
